/**
 * Normalizes a cv object from the database, replacing null/undefined fields
 * with safe default values to prevent schema validation failures.
 *
 * Background: applicants imported via older flows or external parsers may have
 * cv fields (originalFileName, key, size, mimetype) stored as null in MongoDB.
 * These nulls cause APPLICANTEDIT form validation errors when the schema
 * expects string/number values.
 *
 * Related issues: #272 (originalFileName), #280 (all cv fields)
 */

export interface ICvRaw {
    key?: string | null;
    originalFileName?: string | null;
    size?: number | null;
    mimetype?: string | null;
    [key: string]: unknown;
}

export interface ICvNormalized {
    key: string;
    originalFileName: string;
    size: number;
    mimetype: string;
    [key: string]: unknown;
}

/**
 * Normalizes all potentially-null fields of a cv object.
 *
 * @param cv - Raw cv object from the API (fields may be null from MongoDB)
 * @returns A new object with null/undefined fields replaced by safe defaults
 */
export function normalizeCv(cv: ICvRaw): ICvNormalized {
    return {
        ...cv,
        key: cv.key ?? "",
        originalFileName: cv.originalFileName ?? "",
        size: cv.size ?? 0,
        mimetype: cv.mimetype ?? ""
    };
}
